import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { useGetSelectedWorkspace } from './workspace';

const selectWorkspaces = state => state.workspace.workspaces;
const selectCurrentWorkspaceId = (state, selectedWorkspaceId) =>
  selectedWorkspaceId;

const selectWorkspaceCounts = createSelector(
  [selectWorkspaces, selectCurrentWorkspaceId],
  (workspaces, selectedWorkspaceId) => {
    return workspaces.find(ws => ws.id === selectedWorkspaceId)?.counts;
  }
);

export const useWorkspaceCounts = type => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const allCounts = useSelector(state =>
    selectWorkspaceCounts(state, selectedWorkspace.id)
  );

  return type ? allCounts?.[type] : allCounts;
};
